import { format } from "date-fns";

export const LiveBadge = ({ updatedAt }) => (
  <span className="inline-flex h-9 items-center gap-1.5 rounded-md border border-emerald-200 bg-emerald-50 px-2.5 text-xs font-medium text-emerald-800" title="Refreshes automatically every 30 seconds and whenever you return to this tab" data-testid="live-badge">
    <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" /></span>
    Live{updatedAt ? ` · ${format(updatedAt, "h:mm:ss a")}` : ""}
  </span>
);
